import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { CourseProgressByGradeData } from 'teacher-ui-client/components/giraffe/charts/dashboard/course-progress'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface CourseProgressByGradeResponse {
  course_progress_by_grade: {
    grades: { grade_position: number; lesson_count: number; student_count: number }[]
    student_count: number
  }
}

export async function courseProgressByGrade(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  precinct: LegacyPrecinctReading | LegacyPrecinctSpelling | LegacyPrecinctLessons | LegacyPrecinctMyLessons,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressByGradeData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_by_grade', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct })

  const data = await this.fetchData<CourseProgressByGradeResponse>(url, query)
  if (!data) return null

  const {
    course_progress_by_grade: { grades, student_count },
  } = data
  if (grades.length === 0) {
    return null
  }

  const sortedGrades = [...grades].sort((a, b) => a.grade_position - b.grade_position)

  return {
    grades: sortedGrades,
    student_count,
  }
}
